import { Link, useNavigate } from 'react-router-dom';

import { useAuthInfo } from '../../allauth_auth/hooks';
import AuthLayout from '../../layouts/AuthLayout';
import { Flows } from '../../lib/allauth';

interface AuthenticateFlowProps {
  authenticatorType: string;
  children?: React.ReactNode;
}

export default function AuthenticateFlow(props: AuthenticateFlowProps) {
  const authInfo = useAuthInfo();
  const navigate = useNavigate();

  if (authInfo?.pendingFlow?.id !== Flows.MFA_AUTHENTICATE) {
    navigate('/');
    return null;
  }

  return (
    <AuthLayout title='Two-Factor Authentication'>
      <div className='w-full'>
        {/* Header */}
        <div className='mb-8'>
          <h1 className='text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-2'>
            Two-factor authentication
          </h1>
          <p className='text-sm text-gray-600 dark:text-gray-300'>
            Complete your sign-in by entering your authentication code.
          </p>
        </div>

        {/* Form Content */}
        <div className='space-y-6'>
          {props.children}

          {/* Cancel Option */}
          <div className='text-center mt-8'>
            <Link
              to='/account/logout'
              className='text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 font-medium transition-colors'
            >
              Cancel and sign out
            </Link>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
